import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 leading-tight whitespace-normal mr-4" }
const _hoisted_2 = { class: "text-xs leading-tight text-gray-400" }
const _hoisted_3 = { class: "font-medium leading-tight mt-2" }

import { ref, computed, PropType } from "vue";

import { getCodeName, getTypeName } from "@/constants";
import { IOperation } from "@/types/operation";
import { formatDate, formatCurrency } from "@/utils";

import UiCell from "@/plugins/ui/components/cell/UiCell.vue";

import UiIcon from "@/components/ui/UiIcon.vue";

import OperationPreviewModal from "./OperationPreviewModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OperationCell',
  props: {
  operation: { type: Object as PropType<IOperation>, required: true },
},
  setup(__props) {

const props = __props



const showModal = ref(false);

const title = computed(() => getCodeName(props.operation.code));
const type = computed(() => getTypeName(props.operation.type));
const sum = computed(() => formatCurrency(props.operation.sum / 100));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UiCell, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
    }, {
      left: _withCtx(() => [
        (__props.operation.type === 10)
          ? (_openBlock(), _createBlock(UiIcon, {
              key: 0,
              icon: "ArrowSmDown",
              class: "text-green-500"
            }))
          : (__props.operation.type === 20)
            ? (_openBlock(), _createBlock(UiIcon, {
                key: 1,
                icon: "ArrowSmUp",
                class: "text-red-500"
              }))
            : (_openBlock(), _createBlock(UiIcon, {
                key: 2,
                icon: "MinusSm"
              }))
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(title)), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(type)), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(sum)), 1)
      ]),
      _: 1
    }),
    _createVNode(OperationPreviewModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
      operation: __props.operation
    }, null, 8, ["modelValue", "operation"])
  ], 64))
}
}

})